import React from 'react';
import './styles.css';

const Sidebar = ({ post, setPost, handlePublish }) => (
  <div className="Sidebar">
    <div className="SidebarItem">
      <label>Tags</label>
      <input
        type="text"
        placeholder="Separate tags with commas"
        onChange={(e) => setPost({ ...post, tags: e.target.value.split(',') })}
      />
    </div>
    <div className="SidebarItem">
      <button className="Button" onClick={handlePublish}>
        Publish
      </button>
    </div>
  </div>
);

export default Sidebar;
